
import {
  CURRENT_USER_REQUEST_ERROR,
  CURRENT_USER_REQUEST_SUCCESS,
  CURRENT_USER_FETCHING,

  SEARCH_SUCCESS,
  SEARCH_ERROR,
  IS_SEARCHING,
} from './actions'

import {
  GET_CONFIDENCES_SUCCESS,
} from 'routes/AskMeAnything/modules/actions'
import { loadSensitiveConfig } from 'config/app'

const DEFAULT_NODES =
  [
    { "is_leaf": false, "is_root": true, "parent": null, "node_name": "Trang chu", "priority": null, "visible": true, "depth": 0, "node_id": 1, "link": null, "node_description": "", "path": [1], "content": null, "children": [6, 7] },
    {
      "children": [], "content": null, "depth": 1, "is_leaf": true, "is_root": false, "link": "/form/6",
      "node_description": "Thông tin viết hoá đơn công ty", "node_id": 6, "node_name": "Mã số thuế công ty", "parent": 1, "path": [1, 6], "priority": 1, "visible": true,
    },
    {
      "children": [], "content": null, "depth": 1, "is_leaf": true, "is_root": false, "link": "/we_listen",
      "node_description": "Gửi ý kiến của bạn tới các quản lý", "node_id": 7, "node_name": "We Listen", "parent": 1, "path": [1, 7], "priority": 2, "visible": true,
    }
  ]
const DEFAULT_FORM_NODES = [{ "form_name": "vat", "nodes": [{ "is_leaf": false, "leaf_html": "", "parent": null, "question": "Tra cứu mã số thuế", "is_root": true, "depth": 0, "node_id": 1, "answer": "", "path": [1], "children": [2, 3, 4, 5] }, { "is_leaf": true, "leaf_html": "<p>\nCÔNG TY CỔ PHẦN GIẢI TRÍ VÀ THỂ THAO ĐIỆN TỬ VIỆT NAM<br/>\n\nMã số thuế: 0105301438<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 2, "answer": "CÔNG TY CỔ PHẦN GIẢI TRÍ VÀ THỂ THAO ĐIỆN TỬ VIỆT NAM", "path": [1, 2], "children": [] }, { "is_leaf": true, "leaf_html": "\n<p>\nCÔNG TY TNHH DỊCH VỤ PHẦN MỀM BÌNH MINH<br/>\n\nMã số thuế: 0106803303\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 3, "answer": "CÔNG TY TNHH DỊCH VỤ PHẦN MỀM BÌNH MINH", "path": [1, 3], "children": [] }, { "is_leaf": true, "leaf_html": "<p>\nCÔNG TY TNHH DỊCH VỤ PHẦN MỀM THIÊN BÌNH<br/>\n\nMã số thuế: 0106803215\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 4, "answer": "CÔNG TY TNHH DỊCH VỤ PHẦN MỀM THIÊN BÌNH", "path": [1, 4], "children": [] }, { "is_leaf": true, "leaf_html": "<p>\nCông ty TNHH dịch vụ phần mềm Hòa Thái<br/>\n\nMã số thuế: 2801724858\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 5, "answer": "Công ty TNHH dịch vụ phần mềm Hòa Thái", "path": [1, 5], "children": [] }], "form_id": 6 }];

const initialState = {
  loading: false,
  login: false,
  user: {},
  impersonation: null,
  isInternalIP: false,
  pending_my_approval: 0,
  confidences: [],
  banners: [],
  can_access: true,
  nodes: DEFAULT_NODES,
  form_nodes: DEFAULT_FORM_NODES,
  isSearching: false,
  tasks: [],
  adminGames: [],
  currentTime: null,
  registrations: {
    total: 0,
    records: [],
  },
  search_results: {
    total: 0,
    data: []
  },
  isNewStaffTicketId: null
}

export default function currentUserReducer(state = initialState, { type, payload } = action) {
  switch (type) {
    case GET_CONFIDENCES_SUCCESS:
      return {
        ...state,
        confidences: payload
      }
    case CURRENT_USER_REQUEST_SUCCESS:
      loadSensitiveConfig().catch(() => {})
      return {
        ...state,
        loading: false,
        login: true,
        user: payload.user,
        impersonation: payload.impersonation || null,
        isInternalIP: payload.isInternalIP,
        pending_my_approval: payload.pending_my_approval,
        nodes: payload.nodes,
        form_nodes: payload.form_nodes,
        search_results: {
          total: 0,
          data: []
        },
        tasks: payload.tasks || [],
        adminGames: payload.admin_game || [],
        banners: payload.banners || [],
        registrations: {
          records: payload.registrations.records,
          total: payload.registrations.total
        },
        currentTime: payload.current_time,
        isNewStaffTicketId: payload.is_new_staff_ticket_id,
        errorGlobal: ''
      }
      break;
    case CURRENT_USER_REQUEST_ERROR:
      return {
        ...state,
        login: false,
        loading: true,
        isInternalIP: payload.payload?.isInternalIP,
        can_access: payload.error_code == 'access_denied' ? false : true,
        impersonation: payload.payload?.impersonation || null,
        loading: false,
        errorGlobal: 'Không có thông tin user'
      }
      break;
    case CURRENT_USER_FETCHING:
      return {
        ...state,
        login: false,
        loading: true
      }
      break;


    //SEARCH
    case SEARCH_SUCCESS:
      return {
        ...state,
        isSearching: false,
        search_results: payload
      }
      break;
    case SEARCH_ERROR:
      return {
        ...state,
        isSearching: false,
        search_results: {
          total: 0,
          search_results: []
        },
      }
      break;
    case IS_SEARCHING:
      return {
        ...state,
        isSearching: true,
        search_results: {
          total: 0,
          search_results: []
        },
      }
      break;

    default:
      return state
  }
}
